export default (function() {
    var e = { topLat: 90, bottomLat: -90 },
        r = function(t, e, a) {
            var n = a.leftLng,
                r = a.topLat,
                h = a.rightLng,
                i = a.bottomLat,
                g = t / (h - n),
                u = e / (i - r),
                o = -n * g,
                c = -r * u
            return {
                get scaleShift() {
                    return { scaleX: g, scaleY: u, shiftX: o, shiftY: c }
                },
                lng2X: function(t) {
                    return g * t + o
                },
                lat2Y: function(t) {
                    return u * t + c
                },
                x2Lng: function(t) {
                    return (t - o) / g
                },
                y2Lat: function(t) {
                    return (t - c) / u
                }
            }
        },
        a = { topLat: 85.0511287798, bottomLat: -85.0511287798 },
        h = function(t, e, a) {
            var n = a.leftLng,
                r = a.topLat,
                h = a.rightLng,
                i = a.bottomLat,
                g = Math.PI,
                u = t / (h - n),
                o =
                e /
                (Math.log(Math.tan(g / 4 + (g * i) / 360)) -
                    Math.log(Math.tan(g / 4 + (g * r) / 360))),
                c = -n * u,
                f = -Math.log(Math.tan(g / 4 + (g * r) / 360)) * o
            return {
                get scaleShift() {
                    return { scaleX: u, scaleY: (o * g) / 180, shiftX: c, shiftY: f }
                },
                lng2X: function(t) {
                    return u * t + c
                },
                lat2Y: function(t) {
                    return o * Math.log(Math.tan(g / 4 + (g * t) / 360)) + f
                },
                x2Lng: function(t) {
                    return (t - c) / u
                },
                y2Lat: function(t) {
                    return (360 * Math.atan(Math.exp((t - f) / o))) / g - 90
                }
            }
        },
        x = {
            get EPSG3857() {
                return 3857
            },
            get EPSG4326() {
                return 4326
            },
            get WGS84() {
                return this.EPSG4326
            },
            get WebMercator() {
                return this.EPSG3857
            }
        }

    function d(t, e, a, n) {
        switch (t) {
            case x.EPSG4326:
                return r(e, a, n)
            case x.EPSG3857:
                return h(e, a, n)
            default:
                throw '不支援所指定之投影法'
        }
    }

    function L(t, e, a, n) {
        for (
            var r = new Uint32Array(t.data.buffer),
                h = new Uint32Array(e.data.buffer),
                i = t.width,
                g = 0,
                u = e.height; g < u; g++
        )
            for (
                var o = Math.floor(a.lat2Y(n.y2Lat(g + 0.5))), c = 0, f = e.width; c < f; c++
            ) {
                var l = Math.floor(a.lng2X(n.x2Lng(c + 0.5)))
                h[g * f + c] = r[o * i + l]
            }
    }
    return {
        get projList() {
            return x
        },
        getProjBound: function(t) {
            switch (t) {
                case x.EPSG4326:
                    return e
                case x.EPSG3857:
                    return a
                default:
                    throw '不支援所指定之投影法'
            }
        },
        createProjFunc: d,
        createProjFuncWithSameScale: function(t, e, a) {
            switch (t) {
                case x.EPSG4326:
                    return (
                        (L = e),
                        (M = (w = a).leftLng),
                        (m = w.topLat),
                        (v = w.rightLng),
                        (S = w.bottomLat),
                        (E = (p = -(P = L / (v - M))) * (S - m)),
                        (X = -M * P),
                        (Y = -m * p), {
                            get height() {
                                return E
                            },
                            get scaleShift() {
                                return { scaleX: P, scaleY: p, shiftX: X, shiftY: Y }
                            },
                            lng2X: function(t) {
                                return P * t + X
                            },
                            lat2Y: function(t) {
                                return p * t + Y
                            },
                            x2Lng: function(t) {
                                return (t - X) / P
                            },
                            y2Lat: function(t) {
                                return (t - Y) / p
                            }
                        }
                    )
                case x.EPSG3857:
                    return (
                        (n = e),
                        (h = (r = a).leftLng),
                        (i = r.topLat),
                        (g = r.rightLng),
                        (u = r.bottomLat),
                        (o = Math.PI),
                        (l =
                            (f = (180 * -(c = n / (g - h))) / o) *
                            (Math.log(Math.tan(o / 4 + (o * u) / 360)) -
                                Math.log(Math.tan(o / 4 + (o * i) / 360)))),
                        (s = -h * c),
                        (d = -Math.log(Math.tan(o / 4 + (o * i) / 360)) * f), {
                            get height() {
                                return l
                            },
                            get scaleShift() {
                                return {
                                    scaleX: c,
                                    scaleY: (f * o) / 180,
                                    shiftX: s,
                                    shiftY: d
                                }
                            },
                            lng2X: function(t) {
                                return c * t + s
                            },
                            lat2Y: function(t) {
                                return f * Math.log(Math.tan(o / 4 + (o * t) / 360)) + d
                            },
                            x2Lng: function(t) {
                                return (t - s) / c
                            },
                            y2Lat: function(t) {
                                return (360 * Math.atan(Math.exp((t - d) / f))) / o - 90
                            }
                        }
                    )
                default:
                    throw '不支援所指定之投影法'
            }
            var n, r, h, i, g, u, o, c, f, l, s, d, L, w, M, m, v, S, P, p, E, X, Y
        },
        imageTrans: function(t, e, a, n, r, h) {
            var i =
                6 < arguments.length && void 0 !== arguments[6] ?
                arguments[6] :
                'png',
                g = d(a, t.width, t.height, e),
                u = d(n, t.width * r, t.height * h, e),
                o = document.createElement('canvas');
            (o.width = t.width), (o.height = t.height)
            var c = o.getContext('2d')
            c.drawImage(t, 0, 0)
            var f = c.getImageData(0, 0, t.width, t.height),
                l = c.createImageData(t.width * r, t.height * h)
            L(f, l, g, u),
                ((o = document.createElement('canvas')).width = t.width * r),
                (o.height = t.height * h),
                (c = o.getContext('2d')).putImageData(l, 0, 0)
            var s = new Image()
            return (s.src = o.toDataURL('image/' + i)), s
        },
        canvasTrans: function(t, e, a, n, r, h) {
            var i = d(a, t.width, t.height, e),
                g = d(n, t.width * r, t.height * h, e),
                u = t.getContext('2d'),
                o = u.getImageData(0, 0, t.width, t.height),
                c = u.createImageData(t.width * r, t.height * h)
            L(o, c, i, g)
            var f = document.createElement('canvas')
            return (
                (f.width = t.width * r),
                (f.height = t.height * h),
                (u = f.getContext('2d')).putImageData(c, 0, 0),
                f
            )
        }
    }
})()